import TextLink from '../../../../ui/TextLink/TextLink';
import { useTranslations } from '../../../../../hooks/useTranslations';
import { useTheme } from '../../../../../hooks/useTheme';

interface TrackingToggleLinkProps {
  collapsed: boolean;
  onClick: () => void;
}

function TrackingToggleLink({ collapsed, onClick }: TrackingToggleLinkProps) {
  const { linksNoneDefault, linksNoneHover } = useTheme();

  const {
    shippingActivityShowFullHistoryButtonText,
    shippingActivityHideFullHistoryButtonText,
  } = useTranslations();

  const handleClick = () => {
    onClick();
  };

  return (
    <TextLink
      linkStyle={{
        sDefault: { ...linksNoneDefault, display: 'flex' },
        sHover: linksNoneHover,
      }}
      onClick={handleClick}
    >
      {collapsed
        ? shippingActivityShowFullHistoryButtonText
        : shippingActivityHideFullHistoryButtonText}
    </TextLink>
  );
}

export default TrackingToggleLink;
